import { createFileRoute } from "@tanstack/react-router";

import { Updater } from "@/features/updater";

export const Route = createFileRoute("/_authenticated/updater/")({
  component: Updater,
});
